/**
 * Shared policy primitives used across legal pages.
 */
export const PolicyShell = ({ kicker, title, children, testid }) => (
  <div data-testid={testid} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <div className="sb-mono-label">{kicker}</div>
    <h1
      className="mt-2 text-4xl sm:text-5xl font-semibold text-[#1B3A5C] tracking-tight"
      style={{ fontFamily: "Outfit" }}
    >
      {title}
    </h1>
    <div className="mt-10 space-y-6 text-[#475569] leading-relaxed text-[15px]">
      {children}
    </div>
  </div>
);

export const H = ({ children }) => (
  <h2
    className="text-xl font-medium text-[#1B3A5C] mt-10 mb-2"
    style={{ fontFamily: "Outfit" }}
  >
    {children}
  </h2>
);

export const BUSINESS = {
  name: "Sterling Bio Ltd",
  companyNo: "17209385",
  registeredIn: "England & Wales",
  address: "128 City Road, London, EC1V 2NX, United Kingdom",
  phone: "+447916615097",
  phoneDisplay: "+44 7916 615097",
  email: "Info@sterlingbio.co.uk",
};

export const BusinessDetails = () => (
  <div
    data-testid="legal-business-block"
    className="border border-[#E2E8F0] bg-white p-5 my-2 text-sm space-y-1"
  >
    <div className="sb-mono-label !text-[#1B3A5C] mb-3">Merchant identity</div>
    <div><strong>{BUSINESS.name}</strong></div>
    <div>Company No. <strong>{BUSINESS.companyNo}</strong> (registered in {BUSINESS.registeredIn})</div>
    <div>Trading address: {BUSINESS.address}</div>
    <div>
      Telephone:{" "}
      <a className="text-[#2C8C9C] hover:underline" href={`tel:${BUSINESS.phone}`}>
        {BUSINESS.phoneDisplay}
      </a>
    </div>
    <div>
      Email:{" "}
      <a className="text-[#2C8C9C] hover:underline" href={`mailto:${BUSINESS.email}`}>
        {BUSINESS.email}
      </a>
    </div>
  </div>
);
